import { useTranslation } from "react-i18next";

const ServiceOne = () => {
  const { t } = useTranslation();
  const points = t("solutionsSection.points", { returnObjects: true });
  const icons = [
    "/assets/images/icons/entry-and-exit.svg",
    "/assets/images/icons/multi-format-payment-system.svg",
    "/assets/images/icons/real-time-monitoring.svg",
    "/assets/images/icons/video-surveillance-and-monitoring.svg",
    "/assets/images/icons/statistics-and-vehicle-search.svg",
    "/assets/images/icons/managing-white-and-black-lists.svg"
  ]

  return (
    <section id="solutions" className="service padding-y-120 position-relative z-index-1 overflow-hidden section-bg">
      <div className="container container-two">
        <div className="section-heading style-left style-flex flx-between align-items-end gap-3">
          <div className="section-heading__inner w-lg">
            <h3 className="section-heading__title">
              {t("solutionsSection.title")}
            </h3>
            <p className="section-heading__desc">
              {t("solutionsSection.desc")}
            </p>
          </div>
        </div>
        <div className="row gy-4">
          {points.map((point, index) => (
            <div className="col-lg-4 col-sm-6 col-xs-6" key={index}>
              <div className="service-item hover-bg-main">
                {/* <img
                  src="/assets/images/gradients/service-hover-bg.png"
                  alt=""
                  className="hover-bg white-version"
                /> */}
                {/* <img
                  src="/assets/images/gradients/service-hover-bg-dark.png"
                  alt=""
                  className="hover-bg dark-version"
                /> */}
                <span >
                  <img src={icons[index]} alt="" />
                </span>
                <h5 className="service-item__title my-3">{point.title}</h5>
                <p className="service-item__desc">{point.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceOne;

